var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xinxi",attrs:{"id":"xinxi"}},[(_vm.user_component_display)?_c('UserComponent',{attrs:{"getMyUserRelation":_vm.get_my_user_relation,"uinfoBtn":false,"xuejiInfoDisplay":_vm.hideType === 3}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c0cc84e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userCenter/index.vue
// module id = null
// module chunks = 